<template>
  <shared-marketplace-provide-report-product :product="product" :image="getImage()">
    <div class="l-col-12@md" v-if="attributes.length">
      <span class="ds-block" v-for="attribute in attributes"><strong>{{ attribute.name }}:</strong> {{ attribute.value }}</span>
    </div>
  </shared-marketplace-provide-report-product>
</template>

<script>
  import SharedMarketplaceProvideReportProduct from '@/components/marketplace/shared/provide/report/Product'

  export default {
    data: () => ({
      attributes: []
    }),
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.product.attributes.forEach(attribute => {
        const cnovaAttribute = this.product.original.variation.cnovaAttributes.find(cnovaAttribute => cnovaAttribute.id === attribute.id)

        if (cnovaAttribute.select) {
          const value = cnovaAttribute.values.find(value => value.id === attribute.valor)

          this.attributes.push({
            name: cnovaAttribute.name,
            value: value.text
          })
        }
      })
    },
    methods: {
      getImage () {
        if (this.product.images[0] !== undefined) {
          return this.product.images[0]
        }
        return ''
      }
    },
    components: {
      SharedMarketplaceProvideReportProduct
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?a7954b4e